import { createStore, action, Action, createTypedHooks } from 'easy-peasy'
import { IAuthDetails } from '../components/Auhentication/useUserAuthStatus'
import { ISnackbarMessageSeverity } from '../components/SnackbarComponents/MySnackbarIntefaces'

interface StoreModel {
  snackbarMessage: string
  setSnackbarMessage: Action<StoreModel, string>
  snackbarMessageSeverity: ISnackbarMessageSeverity
  setSnackbarMessageSeverity: Action<StoreModel, ISnackbarMessageSeverity>
  isLiveClassActive: boolean
  setIsLiveClassActive: Action<StoreModel, boolean>
  openLiveClass: { courseId: string | undefined; drawerOpened: boolean }
  setOpenLiveClass: Action<
    StoreModel,
    { courseId: string; drawerOpened: boolean }
  >
  isSmallScreen: boolean | undefined
  setIsSmallScreen: Action<StoreModel, boolean>
  authDetails: IAuthDetails | undefined
  storeAuthDetails: Action<StoreModel, IAuthDetails | undefined>
}

export const GlobalStore = createStore<StoreModel>({
  snackbarMessage: '',
  setSnackbarMessage: action((state, payload) => {
    console.log('set snackbar message', payload)
    state.snackbarMessage = payload || ''
  }),
  snackbarMessageSeverity: 'info',
  setSnackbarMessageSeverity: action((state, payload) => {
    state.snackbarMessageSeverity = payload
  }),
  isLiveClassActive: false,
  setIsLiveClassActive: action((state, payload) => {
    state.isLiveClassActive = payload
  }),
  openLiveClass: { courseId: undefined, drawerOpened: false },
  setOpenLiveClass: action((state, payload) => {
    state.openLiveClass = {
      courseId: payload.courseId,
      drawerOpened: payload.drawerOpened,
    }
  }),
  isSmallScreen: undefined,
  setIsSmallScreen: action((state, payload) => {
    state.isSmallScreen = payload
  }),
  authDetails: undefined,
  storeAuthDetails: action((state, payload) => {
    state.authDetails = payload
  }),
})

// hooks for typings
const typedHooks = createTypedHooks<StoreModel>()

export const useGlobalStoreActions = typedHooks.useStoreActions
export const useGlobalStoreDispatch = typedHooks.useStoreDispatch
export const useGlobalStoreState = typedHooks.useStoreState
